import { useEffect, useState } from "react";
import { Save } from "lucide-react";
import api from "@/lib/api";
import { toast, Toaster } from "sonner";
import { useSiteSettings } from "@/lib/SiteSettingsContext";

export default function AdminSettings() {
  const { reload } = useSiteSettings();
  const [form, setForm] = useState({
    whatsapp: "", phone: "", email: "", address: "", instagram: "", linkedin: "", map_embed: "",
  });

  useEffect(() => {
    api.get("/site-settings").then(({ data }) => {
      setForm({ whatsapp: "", phone: "", email: "", address: "", instagram: "", linkedin: "", map_embed: "", ...data });
    });
  }, []);

  const update = (k) => (e) => setForm((p) => ({ ...p, [k]: e.target.value }));

  const save = async () => {
    try {
      await api.put("/admin/site-settings", form);
      toast.success("Ayarlar güncellendi");
      reload();
    } catch (e) {
      toast.error("Hata oluştu");
    }
  };

  return (
    <div data-testid="admin-settings-page" className="max-w-3xl">
      <Toaster position="top-right" />
      <h1 className="heading-font text-3xl text-[#0A2540] mb-8">Site Ayarları</h1>
      <div className="bg-white border border-slate-200 p-8 space-y-5">
        {[
          { k: "whatsapp", label: "WhatsApp Numarası", placeholder: "05423504436" },
          { k: "phone", label: "Telefon" },
          { k: "email", label: "E-posta" },
          { k: "address", label: "Adres", textarea: true },
          { k: "instagram", label: "Instagram URL" },
          { k: "linkedin", label: "LinkedIn URL" },
          { k: "map_embed", label: "Google Map Embed URL", textarea: true },
        ].map((f) => (
          <div key={f.k}>
            <label className="block text-xs uppercase tracking-wider text-slate-500 mb-2">{f.label}</label>
            {f.textarea ? (
              <textarea value={form[f.k]} onChange={update(f.k)} rows={2} className="w-full px-4 py-3 border border-slate-200 focus:border-[#0066FF] outline-none resize-none" data-testid={`settings-${f.k}`} />
            ) : (
              <input type="text" value={form[f.k]} onChange={update(f.k)} placeholder={f.placeholder} className="w-full px-4 py-3 border border-slate-200 focus:border-[#0066FF] outline-none" data-testid={`settings-${f.k}`} />
            )}
          </div>
        ))}
        <button onClick={save} className="inline-flex items-center gap-2 bg-[#0066FF] hover:bg-[#0A2540] text-white px-6 py-3 text-sm font-semibold transition-colors" data-testid="settings-save">
          <Save size={16} /> Kaydet
        </button>
      </div>
    </div>
  );
}
